

import { defineComponent, onMounted } from 'vue';

export default defineComponent({
    name: 'htmltable',
    props: ['header', 'rows'],
    emits: ['init'],
    setup(props, context) {

        onMounted(() => {
            context.emit('init');
        })
        return {

        };
    },
});
